// extracted by mini-css-extract-plugin
module.exports = {"adv":"CJx","desktopTopAdv":"CJnl","mobileTopAdv":"CJnn","placeholder":"CJb5","inread":"CJnp","responsive":"CJnr"};